module.exports = __webpack_public_path__ + "img/image-thumb-9.756f70e1.jpg";